var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast",class:{ error: _vm.error, success: _vm.success }},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('span',{staticClass:"btn",on:{"click":_vm.dismiss}},[_vm._v("Dismiss")])])}
var staticRenderFns = []

export { render, staticRenderFns }